import { useEffect, useState } from "react";
import { checkIsPermissionCliente } from "../protectedRoute/ClientePermissionRoute";
import {
  formatObjectPermissoesCliente,
  lerPermissoesDoLocalStorage,
} from "../../../utils/permissoesCliente";

const getUsuarioClienteId = () => {
  try {
    const data = localStorage.getItem("userCliente");
    if (!data) return "";
    return JSON.parse(data)?.usuarioCliente?.id || "";
  } catch (error) {
    return "";
  }
};

const estadoInicial = () => {
  const doStorage = lerPermissoesDoLocalStorage();

  if (!doStorage) {
    return { admPermissao: false, routesPermissao: {}, carregado: false };
  }

  // Estado síncrono para o menu já nascer correto; o backend confirma logo em seguida
  return { ...doStorage, carregado: true };
};

/**
 * Rotas liberadas para o usuário logado no portal.
 *
 * O estado é derivado do usuário logado (e recarregado quando ele muda), e não
 * do mount do App: o login é uma navegação dentro da SPA, então um estado preso
 * no App.js continuaria refletindo a sessão anterior (ex.: o menu completo de um
 * ADM que acabou de sair) até um F5.
 */
export default function usePermissoesRotasCliente() {
  const usuarioClienteId = getUsuarioClienteId();

  const [permissoes, setPermissoes] = useState(estadoInicial);

  useEffect(() => {
    if (!usuarioClienteId) {
      setPermissoes({
        admPermissao: false,
        routesPermissao: {},
        carregado: false,
      });
      return;
    }

    // Troca de usuário: parte das permissões do novo usuário, não das antigas
    setPermissoes(estadoInicial());

    let ativo = true;

    const carregarPermissoes = async () => {
      try {
        const userPermission = await checkIsPermissionCliente();
        if (!ativo || !userPermission) return;

        // O backend devolve o mapa de rotas liberadas; o localStorage é apenas
        // fallback para sessões antigas salvas antes das permissões de rota
        const routesPermissao =
          userPermission?.routesPermitidas ||
          formatObjectPermissoesCliente(
            JSON.parse(localStorage.getItem("userCliente"))?.usuarioCliente,
          );

        setPermissoes({
          admPermissao: !!userPermission?.isAdmin,
          routesPermissao: routesPermissao || {},
          carregado: true,
        });
      } catch (error) {
        console.error("Erro ao carregar permissões do cliente:", error);
      }
    };

    carregarPermissoes();

    return () => {
      ativo = false;
    };
  }, [usuarioClienteId]);

  return permissoes;
}
